
<add-edit-workout-component [workoutIdInput]="workoutId" [workoutTypeInput]="type" (savedObject)="onWorkoutSaved($event)" (isDirtyChange)="onIsDirtyChange($event)"></add-edit-workout-component>
